
var flashcard_results = function (global) {

    var stats = [];
    var total_viewed = 0;
    var total_unseen = 0;

    _(global.flashcards).each(function(slide) {

        var chapter_id = slide.chapter_id;


        if (typeof stats[chapter_id] == 'undefined') {
            stats[chapter_id] = { viewed: 0, unseen: 0, total: 0 }
        }
        if ( typeof slide.flipped !== 'undefined') {
            stats[chapter_id].viewed++;
            total_viewed++;
        }
        if ( typeof slide.seen == 'undefined') {
            stats[chapter_id].unseen++;
            total_unseen++;
        }
        stats[chapter_id].total++;
    });

    global.viewed = total_viewed;
    global.unseen = total_unseen;

    // var all_chapters_count = 100;
    // if (settings.all_chapter_count < 100 ) {
    //     all_chapters_count = settings.all_chapter_count;
    // }
    var str = '<canvas class="chart"></canvas>Viewed: '+ total_viewed +'<br/>Unseen: '+total_unseen+'<table class="table chapter-table"><tr><th>Chapter</th><th>Viewed</th><th>Unseen</th><th>Total</th></tr>';

    for ( var i = 0; i < global.chapters.length ; i++ ) {
        var chapter = global.chapters[i];
        if ( typeof stats[chapter.id] !== 'undefined') {
            str += '<tr>' +
                '<td><label for="chapter_'+ chapter.id +'">'+ chapter.name+'</label></td>' +
                '<td>'+ stats[chapter.id].viewed +'</td>' +
                '<td>'+ stats[chapter.id].unseen + '</td>' +
                '<td>'+ stats[chapter.id].total +'</td>' +
                '</tr>';
        }

    }
    str +='</table>';
    var table = $.parseHTML(str);


    return table;
}

module.exports = flashcard_results;


//////////////////
// WEBPACK FOOTER
// ./src/flashcard_results.js
// module id = 310
// module chunks = 0